import { CHECKBOX, ORDER_STATUS_ITEMS } from '../constants';

export default {
  DEFAULT: {
    TABLE_COLUMNS: [
      {
        key: 'orderId',
        displayName: 'Order ID',
        width: 0.1,
      },
      {
        key: 'orderAmount',
        displayName: 'Order Amt.',
        width: 0.1,
        align: 'right',
      },
      {
        key: 'cfOrderId',
        displayName: 'CF Order ID',
        width: 0.1,
      },
      {
        key: 'orderType',
        displayName: 'Order Type',
        width: 0.1,
      },
      {
        key: 'orderSource',
        displayName: 'Source',
        width: 0.1,
        tooltip: {
          message: 'Source',
        },
      },
      {
        key: 'customerName',
        displayName: 'Cust. Name',
        width: 0.1,
        tooltip: {
          message: 'Customer Name',
        },
      },
      {
        key: 'customerPhone',
        displayName: 'Cust. Phone',
        width: 0.1,
        tooltip: {
          message: 'Customer Phone',
        },
      },
      {
        key: 'customerEmail',
        displayName: 'Cust. Email',
        width: 0.12,
        tooltip: {
          message: 'Customer Email',
        },
      },
      {
        key: 'orderStatus',
        displayName: 'Status',
        width: 0.08,
      },
    ],
    FILTER_ITEMS: {
      orderStatus: {
        displayText: 'Status',
        type: CHECKBOX,
        items: ORDER_STATUS_ITEMS,
      },
    },
    SEARCH_ITEMS: [
      {
        key: 'orderId',
        text: 'Order ID',
        value: 'orderId',
        placeholder: 'Ex: Order ID 1, Order ID 2',
        inputPattern: '^[\\|\\w\\d ,.-]+$',
        error:
          'Only alphanumeric and special characters (space, comma, dot, hyphen) are allowed.',
      },
      {
        key: 'cforderId',
        text: 'CF Order ID',
        value: 'cforderId',
        placeholder: 'Ex: CF Order ID 1, CF Order ID 2',
        inputPattern: '^[0-9,]+$',
        error: 'Only numbers and comma are allowed.',
      },
      {
        key: 'customerName',
        text: 'Customer Name',
        value: 'customerName',
        placeholder: 'Enter Customer Name',
        inputPattern: '^[a-zA-Z ]+$',
        error: 'Only alphabets and space are allowed.',
      },
      {
        key: 'phoneNumber',
        text: 'Phone Number',
        value: 'customerPhone',
        placeholder: 'Enter Phone Number',
        inputPattern: '^[0-9 +-]+$',
        maxLength: 14,
        error:
          'Only numbers and special characters (space, plus, hyphen) are allowed.',
      },
      {
        key: 'email',
        text: 'Email ID',
        value: 'customerEmail',
        placeholder: 'Enter Email ID',
      },
    ],
  },
};
